import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { WidgetProvider } from "./WidgetContext";
import { BreakpointProvider } from "./WidgetBreakpoint";

import Widget from "./Widget";
import Histogram1 from "./histogram-widgets/Histogram1";
import Histogram2 from "./histogram-widgets/Histogram2";
import Histogram3 from "./histogram-widgets/Histogram3";
import Histogram4 from "./histogram-widgets/Histogram4";

const queries = {
  xs: "(max-width: 320px)",
  sm: "(max-width: 720px)",
  md: "(max-width: 1024px)",
  or: "(orientation: portrait)", // we can check orientation also
};

import "./style.scss";

export default function WidgetContainer(props) {
  useEffect(() => {
    if (props.usersnap) {
      // User snap testing script
      // ------------------------
      window.onUsersnapCXLoad = function (api) {
        api.init();
      };
      const script = document.createElement("script");
      script.text =
        '(function() { var s = document.createElement("script"); s.type = "text/javascript"; s.async = true; s.src = "' +
        props.usersnap +
        '";';
      script.text +=
        "document.getElementsByTagName('head')[0].appendChild(s); })();";

      document.body.appendChild(script);
    }
  }, []);

  return (
    <BreakpointProvider queries={queries}>
      {props.widget === "Histogram1" ? (
        <Histogram1
          inline={props.inline}
          visible={props.visible}
          widgetData={props.widgetData}
          intro={props.intro}
          i18next={props.i18next}
        />
      ) : props.widget === "Histogram2" ? (
        <Histogram2
          inline={props.inline}
          visible={props.visible}
          widgetData={props.widgetData}
          intro={props.intro}
          i18next={props.i18next}
        />
      ) : props.widget === "Histogram3" ? (
        <Histogram3
          inline={props.inline}
          visible={props.visible}
          widgetData={props.widgetData}
          intro={props.intro}
          i18next={props.i18next}
        />
      ) : props.widget === "Histogram4" ? (
        <Histogram4
          inline={props.inline}
          visible={props.visible}
          widgetData={props.widgetData}
          intro={props.intro}
          i18next={props.i18next}
        />
      ) : props.widget === "PCR2" ? (
        <WidgetProvider widgetData={props.widgetData} inline={props.inline}>
          <Widget
            toPrevious={props.toPrevious}
            toNext={props.toNext}
            inline={props.inline}
            visible={props.visible}
          />
        </WidgetProvider>
      ) : null}
    </BreakpointProvider>
  );
}
WidgetContainer.propTypes = {
  widgetData: PropTypes.object,
  usersnap: PropTypes.string,
  inline: PropTypes.boolean,
  // visible: PropTypes.boolean
};
